import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UbviCalendarViewComponent } from './ubvi-calendar-view/ubvi-calendar-view.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [UbviCalendarViewComponent],
  exports: [UbviCalendarViewComponent],
})
export class UbivuCalendarViewModule {}
